/* global axios */
import ApiClient from '../ApiClient';

class HubClient extends ApiClient {
  constructor() {
    super('hub', { accountScoped: true });
  }

  // Requests the onboarding link for an already-created (pending) hub inbox.
  getOnboardingLink(inboxId) {
    return axios.post(`${this.url}/onboarding_link`, { inbox_id: inboxId });
  }

  // GET /hub/posts — paginated Facebook posts for an inbox (25/page).
  getFacebookPosts(inboxId, page = 1) {
    return axios.get(`${this.url}/posts`, {
      params: { inbox_id: inboxId, page },
    });
  }

  // POST /hub/posts — data: { inbox_id, ...content }  (TODO: define content fields)
  createPost(data) {
    return axios.post(`${this.url}/posts`, data);
  }

  // PATCH /hub/posts/:postId — data: { inbox_id, ...content }
  updatePost(postId, data) {
    return axios.patch(`${this.url}/posts/${postId}`, data);
  }

  // DELETE /hub/posts/:postId — params: { inbox_id }
  deletePost(postId, params) {
    return axios.delete(`${this.url}/posts/${postId}`, { params });
  }

  // POST /hub/comments/:messageId/like — like/unlike a Facebook page comment.
  toggleCommentLike(messageId, { inboxId, like }) {
    return axios.post(`${this.url}/comments/${messageId}/like`, {
      inbox_id: inboxId,
      like,
    });
  }

  // POST /hub/comments/:messageId/hide — hide/unhide a Facebook page comment.
  toggleCommentHide(messageId, { inboxId, hide }) {
    return axios.post(`${this.url}/comments/${messageId}/hide`, {
      inbox_id: inboxId,
      hide,
    });
  }
}

export default new HubClient();
